import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Modal,
  Grid
} from '@material-ui/core';

import { saveEntity } from '../../../../entities/services/entities';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalPaper: {
    padding: theme.spacing(6),
  },
}));

const RecomendationModal = (props) => {
  const { user } = props;
  const { id, interviews } = user;

  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [newInterviews, setNewInterviews] = useState(interviews);

  const handleConfirm = async () => {
    // const response = await saveEntity({ entity: 'student', values: { interviews: newInterviews }, id });
    // const { success, msg, data } = response;
  };


  return (
    <>
      <Button size="small" color="primary" onClick={() => setIsOpen(true)}>
        Añadir entrevista
      </Button>
      <Modal
        className={classes.modal}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Card className={classes.modalPaper}>
          <CardHeader title="Añadir entrevista" />
          <CardContent>
            Formulario para añadir entrevista
          </CardContent>

          <CardActions>
            <Grid container item justifyContent="flex-end" xs={12} spacing={2}>
              <Grid item xs={6}>
                <Button
                  color="secondary"
                  fullWidth
                  onClick={() => setIsOpen(false)}
                  size="large"
                  type="button"
                  variant="contained"
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="primary"
                  fullWidth
                  onClick={handleConfirm}
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          </CardActions>

        </Card>
      </Modal>
    </>
  );
};

RecomendationModal.propTypes = {};

RecomendationModal.defaultProps = {};

export default RecomendationModal;
